import ol = require("ol");
import _ = require("underscore");
import Portal = require("portal-gis");
import Utils = require("../utils");
import Mediator = require("../mediator");
import Templates = require("../models/defaults");
import View = require("../controls/view");
import Base = require("./base-command");
import Converter = require("../utils/ol3/converter");

// generalized to launch any controller but launches the InfoViewer by default
class Handler extends Base<{ in: any; out: any; }> {

    static about = `
Generalized to launch any controller but launches the InfoViewer by default.
    `;

    static options = {
        "control": {
            "about": "Identify the  infoviewer control",
            "default": "app/controls/infoviewer",
        },
        "control-id": {
            "about": "The id to assign to the control",
            "default": "_id_-controller",
        },
        "template": {
            "about": "The infoviewer template",
            "default": "app/templates/infoviewer-template",
        },
    }

    static input = {
        "feature": {
            "about": "The feature to render",
        },
        "layer": {
            "about": "The layer associated with the feature",
        },        
        "layers": {
            "about": "Render all features in these layers",
        },
        "selected": {
            "about": "The feature to render",
        },
    }

    static output = {
        "viewer": {
            "about": "InfoViewer instance for viewing the data associated with a feature.",
        },
    }

    execute(args = this.args) {

        let options = _.defaults(this.asOptions(Handler.options), {
            "control-id": `${this.configuration.id}-controller`,
        });

        let control = Templates.asControlTemplate({
            id: options["control-id"],
            Options: {
                Values: [{
                    id: "template",
                    value: options["template"]
                }, {
                    id: "use-svg",
                    value: options["use-svg"] || "true"
                }]
            }
        });

        Utils.withModule(View, options["control"], InfoViewer => {
            let showCoordinates = this.findOption("show-coordinates") === "true";
            if (showCoordinates) {
                let box = this.findArg("box", this).box;
                if (!box) return;
                let center = ol.extent.getCenter(box);
                let viewer = new InfoViewer(control, this.mediator, {
                    out: {
                        layers: [{
                            features: [{
                                geometry: center,
                                geometryType: "point",
                                attributes: {
                                    lon: center[0],
                                    lat: center[1]
                                }
                            }]
                        }]
                    }
                });
                viewer.createView();

                this.trigger({ viewer: viewer });
                return;
            }

            // just testing for now...will need to provide "layers" to support paging            
            let syntheticHack = this.findOption("syntheticHack");
            if (syntheticHack && syntheticHack.length) {
                this.mediator.mapViewMap(map => {
                    let converter = new Converter(map.getView().getProjection().getCode());

                    let layers = syntheticHack.map(hack => {
                        let layer = converter.fromNativeFeatures(hack.features);
                        // bind the 'fake' layer to the ol3 layer so viewer
                        // can find symbology and other configuration options
                        this.mediator.extensions.bind(layer, hack.layer);
                        return layer;
                    });

                    let viewer = new InfoViewer(control, this.mediator, {
                        out: {
                            layers: layers
                        }
                    });
                    viewer.createView();

                    this.trigger({ viewer: viewer });
                });
                return;
            }

            let layers = <Array<any>>this.findOption("layers");
            if (!layers || !layers.length) {
                let events = <Array<{ eventArgs: any; eventName: string; }>>this.findArg("events", args).events;
                if (events && Array.isArray(events)) {
                    events.forEach(event => {
                        let eventLayers = <[{ count: number, features: Array<any> }]>this.findArg("layers", event.eventArgs).layers;
                        if (eventLayers && Array.isArray(eventLayers)) {
                            layers = (layers || []).concat(eventLayers);
                        }
                    });
                }
            }
            if (layers) {
                if (!layers.length) return;
                let viewer = new InfoViewer(control, this.mediator, {
                    out: {
                        layers: layers
                    }
                });
                viewer.createView();

                this.trigger({ viewer: viewer });
                return;
            }

            let selected = this.findOption("selected");
            if (selected) {
                if (!selected.length) return;
                let layer = { features: selected };
                let viewer = new InfoViewer(control, this.mediator, {
                    out: {
                        layers: [layer]
                    }
                });
                viewer.createView();

                this.trigger({ viewer: viewer });
                return;
            }

            {
                // makes popup-tool compatible with native features and layers
                let feature = this.findOption("feature");
                let layer = this.findOption("layer");
                if (feature && layer) {
                    this.ol3FeatureHandler(control, InfoViewer, {
                        feature: feature,
                        layer: layer
                    });
                }
            }
        });

    }

    /**
     * feature-selection-tool does something similar
     *  bind the 'fake' layer to the ol3 layer
     */
    private ol3FeatureHandler(control: Portal.ControlLeaf, InfoViewer: typeof View, args: {
        feature: ol.Feature,
        layer: ol.layer.Vector
    }) {

        this.mediator.mapViewMap(map => {
            let converter = new Converter(map.getView().getProjection().getCode());
            let layer = converter.fromNativeFeatures([args.feature]);

            // bind the 'fake' layer to the ol3 layer so viewer
            // can find symbology and other configuration options
            this.mediator.extensions.bind(layer, args.layer);

            // TODO: danger!  only works with polygons right now            
            let point = args.feature
                .getGeometry()
                .getInteriorPoint()
                .transform(map.getView().getProjection().getCode(), "EPSG:4326")
                .getCoordinates();

            console.log(`popup-tool: ${point}`);

            let viewer = new InfoViewer(control, this.mediator, {
                out: {
                    layers: [layer],
                    point: point
                }
            });
            viewer.createView();

            this.trigger({ viewer: viewer });
            return;

        });

    }
}

export = Handler;  